<template>
    <div class="slideshow">
        <img ref="slideshowImage1" :src="backgrounds[background1Index].url" :class="{'fade-out': background1FadeOut}">
        <img ref="slideshowImage2" :src="backgrounds[background2Index].url" :class="{'fade-out': !background1FadeOut}">
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex';
    import backgrounds from './../data/backgrounds.json'

    export default {
        data() {
            return {
                backgrounds: backgrounds,
                background1Index: 0,
                background2Index: 1,
                background1FadeOut: false,
                timer: null
            }
        },
        computed: {
            ...mapState({
                channel: state => state.channels.currentChannel
            })
        },
        methods: {
            startSlideshowTimer() {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.channel.is_video) {
                        clearInterval(this.timer);
                    }
                    else {
                        this.background1FadeOut = !this.background1FadeOut;

                        if (this.background1FadeOut) {
                            let newIndex = this.background1Index + 2;
                            setTimeout(() => {
                                if (newIndex <= (this.backgrounds.length - 1))
                                    this.background1Index += 2;
                                else
                                    this.background1Index = 0;
                            }, 500); // Время анимации исчезновения, после анимации меняем картинку у первой
                        }
                        else {
                            let newIndex = this.background1Index + 1;
                            setTimeout(() => {
                                if (newIndex <= (this.backgrounds.length - 1))
                                    this.background2Index = this.background1Index + 1;
                                else
                                    this.background2Index = 1;
                            }, 500);
                        }
                    }
                }, 20000);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Slideshow.vue?3591e942